import React, { useState } from "react";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import moment from "moment/moment";
import "../eventSlider/eventSlider.scss"

const VISIBLE_ITEMS = 7;

const EventSlider = ({ items, isLoading }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const maxIndex = Math.max(0, items.length - VISIBLE_ITEMS);

    const next = () => {
        setCurrentIndex((prev) => Math.min(prev + VISIBLE_ITEMS, maxIndex));
    };

    const prev = () => {
        setCurrentIndex((prev) => Math.max(prev - VISIBLE_ITEMS, 0));
    };

    const translateX = -(currentIndex * (100 / VISIBLE_ITEMS));

    return isLoading ? (<div className="loading" />) : (
        <div className="eventSlider">
            <button className="nav left" onClick={prev} disabled={currentIndex === 0}>
                <ChevronLeftIcon />
            </button>
            <div className="sliderContainer">
                <div
                    className="sliderTrack"
                    style={{ transform: `translateX(${translateX}%)` }}
                >
                    {items.map((event) => (
                        <div className="item" key={event.id}>
                            <div className="content">
                                <span className="day">{moment(event.created_at).format("D.")}</span>
                                <span className="month">{moment(event.created_at).format("MMM")}</span>
                                <img src={"https://api.kolhaupt.it/uploads/" + event.img} alt={"EventSlider"} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <button className="nav right" onClick={next} disabled={currentIndex === maxIndex}>
                <ChevronRightIcon />
            </button>
        </div>
    )
};

export default EventSlider